import baseURL from "../baseUrl";

export const useInsertData = async (url, params) => {
  const token = localStorage.getItem("token");
  const lang = localStorage.getItem("language") || "en";

  let configInsert = {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
      lang: lang,
    },
  };
  // try{
  // const res=await baseURL.post(url,params);
  const res = await baseURL.post(url, params, configInsert);
  return res.data;
  // } catch(error){

  // }
};

export const useInsertDataWithImage = async (url, params) => {
  const token = localStorage.getItem("token");

  const lang = localStorage.getItem("language") || "en";

  const configInsert = {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "multipart/form-data",
      lang: lang,
    },
  };
  const res = await baseURL.post(url, params, configInsert);
  return res.data;
};
